export default {"src":"/_next/static/media/prismatic-icon.037f21cf.svg","height":66,"width":66,"blurWidth":0,"blurHeight":0};